import { CSSProperties } from "react";
import { Crystal, CrystalProps } from "./Crystal";
import { classNamesOrEmpty } from "../../style/common";

export type CrystalWithCostProps = Omit<CrystalProps, 'className' | 'styles'> & {
    cost: number,
    classNames?: {
        container?: string | undefined,
        crystal?: string | undefined
    },
    styles?: {
        container?: CSSProperties | undefined,
        crystal?: CSSProperties | undefined
    }
}

export function CrystalWithCost(props: CrystalWithCostProps) {
    const crystalStyles = props.styles?.crystal ?? {};

    return (
        <div className="grid items-center justify-items-center">
            <div className="z-10 col-start-1 row-start-1 text-white text-2xl" style={{ fontFamily: "futura-pt-bold", textShadow: "0 0 3px black" }}>{props.cost}</div>
            <Crystal elements={props.elements} className={`${classNamesOrEmpty(props.classNames?.crystal)} col-start-1 row-start-1 drop-shadow shadow-white`} styles={{...crystalStyles}} />
        </div>
    )
}